// extracted by css-extract-rspack-plugin
export default {"wrapper":"_9756f57a","tagItem":"_305dd58e","tagLink":"_61ffa8db","tagRemoveIcon":"_dc2d5616"};